import React, { useEffect } from 'react';
import '../styles/ImageLightbox.css';

// Simple fullscreen image viewer - click the backdrop, press Escape, or use the close button to dismiss.
const ImageLightbox = ({ isOpen, src, alt, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !src) return null;

  return (
    <div className="image-lightbox-overlay" onClick={onClose}>
      <button className="image-lightbox-close" onClick={onClose} aria-label="Close">
        &times;
      </button>
      <img src={src} alt={alt || ''} className="image-lightbox-img" onClick={(e) => e.stopPropagation()} />
    </div>
  );
};

export default ImageLightbox;
